<template>
<div class="chapter">
<div class="inner_page">
<p class="OT1"><a id="page_vi"></a><a id="page_vii">Contents</a></p><a id="page_vii">
</a><p class="TocSb1" id="for"><a id="page_vii"></a><a href="#/xhtml/foreword#for"><i>Foreword</i> by Makoto Fujimura</a></p>
<p class="Toc" id="tran"><a href="#/xhtml/frontmatter001#tran">Translator’s Note</a></p>
<p class="Toc" id="pre"><a href="#/xhtml/preface#pre">Preface</a></p>
<p class="Toc1" id="ch-001"><a href="#/xhtml/chapter001#ch001">1.<span class="space1">The Singing Tree</span></a></p>
<p class="Toc1" id="ch-002"><a href="#/xhtml/chapter002#ch002">2.<span class="space1">The Tree’s Wisdom</span></a></p>
<p class="Toc1" id="ch-003"><a href="#/xhtml/chapter003#ch003">3.<span class="space1">The Design</span></a></p>
<p class="Toc1" id="ch-004"><span href="#/xhtml/chapter004#ch004" title="Link target outside of Sample">4.<span class="space1">Tone Colors</span></span></p>
<p class="Toc1" id="ch-005"><span href="#/xhtml/chapter005#ch005" title="Link target outside of Sample">5.<span class="space1">The Arching and the Wood’s Grain</span></span></p>
<p class="Toc1" id="ch-006"><span href="#/xhtml/chapter006#ch006" title="Link target outside of Sample">6.<span class="space1">To Be an Instrument</span></span></p>
<p class="Toc1" id="ch-007"><span href="#/xhtml/chapter007#ch007" title="Link target outside of Sample">7.<span class="space1">The Closed Sound</span></span></p>
<p class="Toc1" id="ch-008"><span href="#/xhtml/chapter008#ch008" title="Link target outside of Sample">8.<span class="space1">Reworking the Violin</span></span></p>
<p class="Toc1" id="ch-009"><span href="#/xhtml/chapter009#ch009" title="Link target outside of Sample">9.<span class="space1">The Sculpture (I)</span></span></p>
<p class="Toc1" id="ch-010"><span href="#/xhtml/chapter010#ch010" title="Link target outside of Sample">10.<span class="space05">The Charisma of the Stradivarius</span></span></p>
<p class="Toc1" id="ch-011"><span href="#/xhtml/chapter011#ch011" title="Link target outside of Sample">11.<span class="space05">The Secret of the Varnish</span></span></p>
<p class="Toc1" id="ch-012"><a id="page_viii"></a><span href="#/xhtml/chapter012#ch012" title="Link target outside of Sample">12.<span class="space05">The Inner Fire</span></span></p>
<p class="Toc1" id="ch-013"><span href="#/xhtml/chapter013#ch013" title="Link target outside of Sample">13.<span class="space05">The Concert</span></span></p>
<p class="Toc1" id="ch-014"><span href="#/xhtml/chapter014#ch014" title="Link target outside of Sample">14.<span class="space05">The Sculpture (II)</span></span></p>
<p class="Toc1" id="ch-015"><span href="#/xhtml/chapter015#ch015" title="Link target outside of Sample">15.<span class="space05">Conclusion</span></span></p>
<p class="Toc" id="ack"><span href="#/xhtml/acknowledgements#ack" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="Toc" id="note"><span href="#/xhtml/notes#note" title="Link target outside of Sample">Notes</span></p>
<p class="Toc" id="idx-001"><span href="#/xhtml/index001#idx001" title="Link target outside of Sample">Index of Names and Places</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?4623c3ac